<div class="select-container" [class.disabled]="control.disabled">
  <span class="select-label">{{ label }}</span>
  <mat-form-field
    hideRequiredMarker="true"
    [class.panel-open]="select?.panelOpen"
    id="dropdownField">
    <mat-label
      class="label"
      *ngIf="
        (!control.value || (control.value && !control.value.id)) &&
        !select.panelOpen
      ">
      <mat-icon
        [class.resident]="isResidentDropdown"
        [class.department]="!isResidentDropdown"
        [svgIcon]="getIcon()"></mat-icon>
      {{ isResidentDropdown ? 'Bewohner auswählen' : 'Wohnbereich auswählen' }}
    </mat-label>
    <mat-select
      style="display: flex !important"
      [formControl]="control"
      [compareWith]="compareFunction"
      #select
      [panelClass]="panelClass"
      (selectionChange)="selectionChange.emit($event)">
      <div
        class="filter-options-container"
        *ngIf="select.panelOpen && showSearch">
        <mat-icon class="search-icon" svgIcon="search-icon"></mat-icon>
        <input
          #filterInput
          [placeholder]="searchPlaceholder"
          [formControl]="filterControl"
          (click)="listFilterClick($event)" />
      </div>
      <mat-select-trigger>
        <ng-container *ngIf="!select.panelOpen">
          <ng-content select="[selected-item]"></ng-content>
        </ng-container>
      </mat-select-trigger>
      <mat-option
        [class.b2bDepartment]="option?.isB2B"
        *ngFor="let option of options"
        [value]="option"
        [ngClass]="{
          selected: selectedId === option.id,
          hidden: shouldBeHidden(option)
        }">
        <div class="break"></div>
        <ng-container
          *ngTemplateOutlet="
            optionTemplate;
            context: { $implicit: option }
          "></ng-container>
      </mat-option>
      <div
        class="add-resident-option"
        (click)="addResident()"
        *ngIf="
          isResidentDropdown &&
          permissionsService.canManageResidents() &&
          !selectedDepartment?.partnerDepartmentId &&
          !selectedDepartment?.isMyNeva
        ">
        <mat-icon
          svgIcon="add-resident-dropdown-icon"
          class="add-resident-dropdown-icon"></mat-icon>
        <span>{{ 'dropdown.addResident' | translate }}</span>
      </div>
    </mat-select>
    <mat-icon
      matSuffix
      class="arrow-icon"
      svgIcon="back-icon"
      (click)="closeSelect($event)">
      expand_more
    </mat-icon>
  </mat-form-field>
</div>
